import inspectionHistory from "Modules/evirPx/tabs/inspectionHistory/lan/es";
import defectsGtc from "Modules/evirPx/tabs/defectsGtc/lan/es";

let locales = {
  evirPx_inspection_history: "Historial de Inspección",
  evirPx_defects: "Defectos",
  evirPx_missing_inspections: "Inspecciones Faltantes",
  evirPx_inspection_builder: "Constructor de Inspección",
  evirPx_settings: "Configuración",
  evirPx_record: "registro",
  evirPx_records: "registros",
};

locales = {
  ...locales,
  ...inspectionHistory,
  ...defectsGtc,
};

export default locales;
